import { CustomersPriceTablesDto } from '@tiendanube/common';
import axios from 'App/axios';
import { GetCustomerPriceTablesType } from 'domains/Customers/CustomerPriceTables/customerPriceTablesService/types';

export const getCustomerPriceTables: GetCustomerPriceTablesType = async (
  customerId,
) => {
  const { data } = await axios.get<CustomersPriceTablesDto[]>(
    `/price-tables/customers/${customerId}`,
  );
  return data;
};

const customerPriceTablesService: {
  getCustomerPriceTables: GetCustomerPriceTablesType;
} = {
  getCustomerPriceTables,
};

export default customerPriceTablesService;
